<template>
  <v-card>
    <v-card-title>
      {{ $t("user.dashboard.interview.title") }}
    </v-card-title>

    <v-card-text>
      <Markdown :value="$t('user.dashboard.interview.description')" />
    </v-card-text>

    <v-card-actions>
      <v-btn
        :to="{
          name: 'userAuditPeriodInterview',
          params: { id: auditPeriod.id },
        }"
        color="primary"
      >
        {{ $t("user.dashboard.interview.cta") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    auditPeriod: {
      type: Object,
      required: true,
    },
  },
};
</script>
